export default __webpack_public_path__ + "static/media/aruLogo.7a8370c7.svg";